import { AnnotationEngine } from './engine/annotation_engine';

export const AnnotationEngineFactory = {
    create: function (options, eventBus) {
        return new AnnotationEngine(options, eventBus);
    }
};
